import { render, staticRenderFns } from "./LocationsLosAngeles.vue?vue&type=template&id=450d64b1&lang=pug&"
import script from "./LocationsLosAngeles.vue?vue&type=script&lang=ts&"
export * from "./LocationsLosAngeles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports